import { render, staticRenderFns } from "./DiscrepancyCheck.vue?vue&type=template&id=52feec32"
import script from "./DiscrepancyCheck.vue?vue&type=script&lang=js"
export * from "./DiscrepancyCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports